import Vue from 'vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

Vue.component('datepicker-component', {
    props: {
        inputId: {
            type: String,
        },
        labelId: {
            type: String,
        },
        errors: {
            type: Object,
        },
    },

    data() {
        return {
            selectedDate: null,
            input: null,
            inputContainer: null,
            inputValue: '',
            datepickerAttributes: {
                name: this.inputId,
                id: this.inputId,
            },
            isErrorVisible: false,
        };
    },
    components: {
        datepicker: DatePicker,
    },

    watch: {
        selectedDate() {
            this.handleInputLabelMoved();
        },

        errors: {
            handler: function (newErrors) {
                if (!newErrors.errors.hasOwnProperty(this.inputId)) {
                    this.isErrorVisible = false;
                    return;
                }

                this.isErrorVisible = true;
            },
            deep: true,
        },
    },

    mounted() {
        this.input = document.getElementById(this.inputId);
        this.inputContainer = document.getElementById(
            'container-' + this.inputId,
        );
    },

    computed: {
        handleShowContainerError() {
            return this.isErrorVisible ? 'new-input__container--error' : '';
        },

        handleMaintenanceDateEmptyError() {
            return this.handleErrorChecks('maintenanceDate', 'blank');
        },

        handleDesiredDateEmptyError() {
            return this.handleErrorChecks('desiredDate', 'blank');
        },
    },

    methods: {
        handleHiddenError() {
            return 'new-input__error--hidden';
        },

        handleErrorCustomInputChecks(
            errorMessage,
            customErrorKey = null,
            customInputId = null,
        ) {
            const inputId = customInputId || this.inputId;

            const hasError = this.errors.errors.hasOwnProperty(customErrorKey);

            if (!hasError) return this.handleHiddenError();

            const isError =
                this.errors.errors[customErrorKey || inputId][0].includes(
                    errorMessage,
                );

            if (!isError) return this.handleHiddenError();
        },

        handleErrorChecks(id, errorMessage, customErrorKey = null) {
            if (!this.inputId.includes(id)) return this.handleHiddenError();

            const hasError = this.errors.errors.hasOwnProperty(this.inputId);

            if (!hasError) return this.handleHiddenError();

            const isError =
                this.errors.errors[customErrorKey || this.inputId][0].includes(
                    errorMessage,
                );

            if (!isError) return this.handleHiddenError();
        },

        handleInputLabelMoved() {
            const label = document.getElementById(this.labelId);
            if (!label) return;

            const isInputEmpty = this.selectedDate.length === 0;

            if (isInputEmpty) {
                this.handleRemoveLabelClass(label);
                return;
            }

            this.handleAddLabelClass(label);
        },

        handleAddLabelClass(label) {
            if (this.isTextArea) {
                label.classList.add('new-input__textarea-label--moved');
                return;
            }

            label.classList.add('new-input__label--moved');
        },

        handleRemoveLabelClass(label) {
            if (this.isTextArea) {
                label.classList.remove('new-input__textarea-label--moved');
                return;
            }

            label.classList.remove('new-input__label--moved');
        },
    },
});
